import React, { FC, useEffect } from "react";

import { FormSettings, useMultistepFormStore } from "./MultistepForm.store";
import MultistepForm from "./MultistepForm";

interface MultistepFormContainer {
  formSettings: FormSettings;
  isSubmissionPending: boolean;
}

const MultistepFormContainer: FC<MultistepFormContainer> = ({
  formSettings,
  isSubmissionPending,
}) => {
  const {
    formSettings: {
      formBasics: { id },
    },
    setFormSettings,
    resetStore,
    setIsSubmissionPending,
  } = useMultistepFormStore();

  useEffect(() => {
    setFormSettings(formSettings);

    return () => {
      resetStore();
    };
  }, [formSettings]);

  useEffect(() => {
    setIsSubmissionPending(isSubmissionPending);
  }, [isSubmissionPending]);

  return id && <MultistepForm />;
};

export default MultistepFormContainer;
